$(document).ready(function() {

    $('.spec-view').click(
      function()
      {
        $.ajax(
          {
            url:  '/ajax/getSpecializationListing',
            type: 'POST',
            data: {
              YII_CSRF_TOKEN: token
            }
          }
        )
          .done(
            function(response)
            {
              response = JSON.parse(response);
              if (response.code == 0) {
                $('#modal-windows').html(response.response);

                $('#dialog').modal();
              }
            }
          );
      }
    );

  const checkAttempt = ()=>{
    const errorText = $('#freelancersImportError').text().replaceAll('\n','').replaceAll('  ','');
    const isRepeat = window.sessionStorage.getItem('isButtonClicked') || !!errorText;
    if (isRepeat) {
      const errorTxt = !!errorText ? errorText : 'empty';
      const status = !!errorText ? 'cancel' : 'ok';
      const userIdEl = document.getElementById('userId');
      const userId = userIdEl ? userIdEl.content : '0';
      try {
        if (typeof window.ym === 'function') {
          window.ym(29709265, 'reachGoal', 'freelancers_import', {
            status: status,
            error: errorTxt,
            user_id: userId
          });
        }
      } catch (_) {}
    }
  }

  checkAttempt();

  $('#freelancersImportSubmit').on('click', function(){
    if (!window.sessionStorage.getItem('isButtonClicked')) {
      window.sessionStorage.setItem('isButtonClicked', 'true');
    }
  })
  }
);